(function () {
  'use strict';

  /* @ngdoc object
   * @name compartilhamentos
   * @description
   *
   */
  angular
    .module('veiculos', [
      'ui.router',
      'uoModule',
      'uoArvoreNivelModule',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule',
      'restangular'
    ]);
}());
